import React, { useState, useEffect, useRef } from 'react';
import importAllImg from "../helpers/import-all-imgs";
import { useIntl } from 'react-intl';
import { useNavigate } from "react-router-dom";
import heroVideo from '../video/NP Family Video - Hero Image.mp4';

const imgs = importAllImg(require.context('../img/npf', false, /\.(png|jpe?g|svg)$/));

function Home() {

  const navigate = useNavigate();
  const { formatMessage, locale } = useIntl();

  const fm = id => formatMessage({id});

  return (
      <div>
        <div className='mt-14 md:mt-24' >
          <video
            className='w-full md:-mt-20'
            src={heroVideo}
            autoPlay muted loop playsInline>
          </video>
        </div>

        {/* about panel */}
        <div className='bg-[#354402] py-5 md:py-20 px-5 flex flex-col items-center justify-center text-center text-white -mt-1 md:mt-auto'>
          <div className='uppercase text-xs md:text-base mb-1 md:mb-3 tracking-wider'>
            {fm('ABOUT US')}
          </div>
          <div className='text-xl md:text-4xl font-bold mb-2 md:mb-4'>
            {fm('Who we are')}
          </div>
          <div className='text-base md:text-lg max-w-3xl leading-relaxed mb-4 md:mb-10 px-4'>
            {
              locale === 'en' ?
                <>
                  The Nguyễn-Phương Foundation is inspired by the vision that <b> ‘We are One’</b> - all humans, all creatures and the earth. We aim to consciously link this awareness with our philanthropic work, and help build a world based on well-being, service, and dignity for all.
                </> :
                <>
                  Gia đình Nguyễn-Phương được truyền cảm hứng từ tầm nhìn <b>‘Chúng ta là Một’</b> - tất cả con người, mọi sinh vật và trái đất. Chúng tôi mong muốn liên kết một cách có ý thức nhận thức này với công việc từ thiện của mình và giúp xây dựng một thế giới dựa trên hạnh phúc, dịch vụ và phẩm giá cho tất cả mọi người.
                </>
            }
          </div>
          <button
            onClick={() => navigate('/about')}
            className='bg-[#85AA05] hover:bg-[#5a7a1d] text-white font-semibold py-2 md:py-3 px-8 rounded-2xl transition-colors duration-200'
          >
            {fm('Learn About Us')}
          </button>
        </div>

        <div>
          <img src={imgs['pexels-braven-nguyen-1173174-139948031.png']} className='w-[100%] h-[175px] md:h-auto' />
        </div>

        {/*our approach*/}
        <div className='bg-[#354402] py-10 md:py-32 px-5 flex flex-col items-center justify-center text-center text-white'>
          <div className='uppercase text-xs md:text-base mb-2 md:mb-6 tracking-wider'>
            {fm('Our Approach')}
          </div>
          <div className='text-xl md:text-4xl mb-4 md:mb-8 max-w-3xl leading-tight'>
            {
              locale === 'en' ?
                <>
                  <b> We need a new Radical Philanthropy</b> to create meaningful change.
                </> :
                <>
                  Chúng ta cần một tổ chức <b>từ thiện cấp tiến</b> mới để tạo ra sự thay đổi có ý nghĩa.
                </>
            }
          </div>
          <div className='text-base md:text-lg max-w-3xl leading-relaxed px-4 space-y-4'>
            <p>
              {
                locale === 'en' ?
                  <>
                    The Nguyễn-Phương Foundation supports organizations and Changemakers that enhance the wellbeing of humanity. We do this through investment, collaborations and resource sharing. We are strong believers in promoting inner transformation, systems change and patient capital. Our philanthropic work is currently focused across South East Asia.
                  </> :
                  <>
                    Chúng ta đang sống trong thời kỳ có những thách thức toàn cầu chưa từng có. Chúng ta cần một tổ chức từ thiện cấp tiến mới để tạo ra sự thay đổi có ý nghĩa. Gia đình Nguyễn-Phương hỗ trợ các tổ chức và Người tạo ra sự thay đổi nhằm nâng cao phúc lợi của nhân loại. Chúng tôi thực hiện điều này thông qua đầu tư, hợp tác và chia sẻ tài nguyên. Chúng tôi rất tin tưởng vào việc thúc đẩy chuyển đổi nội tâm, thay đổi hệ thống và vốn kiên nhẫn. Công việc từ thiện của chúng tôi hiện đang tập trung trên khu vực Đông Nam Á.
                  </>
              }
            </p>
          </div>
        </div>

        {/*Our service focus areas*/}
        <div className='bg-[#F5F4EE] py-8 md:py-16 px-5 md:px-10'>
          <div className='max-w-7xl mx-auto'>
            <div className='uppercase text-xs md:text-xl text-[#354402] mb-1 md:mb-3 tracking-wider text-center'>
              {fm('OUR SERVICE FOCUS AREAS')}
            </div>
            <div className='text-xl md:text-4xl font-bold text-black mb-4 md:mb-12 text-center'>
              {fm('What We Care About')}
            </div>

            {/* Cards Grid */}
            <div className='grid grid-cols-1 md:grid-cols-3 gap-x-12 gap-y-6 mb-6'>
              {/* Inner Transformation */}
              <div
                onClick={() => navigate('/ourservice/innertransformation')}
                className='group relative bg-[#3A1F3D] rounded-2xl p-8 text-white cursor-pointer overflow-hidden flex flex-col justify-between min-h-[300px] transition-all duration-500'
              >
                <img src={imgs['Meditationa.svg']} className='block md:hidden w-[50px]'/>

                <img
                  src={imgs['Group 1.png']}
                  alt="Inner Transformation"
                  className='absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-500'
                />
                <div className='relative z-10'>
                  <div className='text-2xl md:text-4xl font-bold mb-4'>
                    {fm('INNER TRANSFORMATION')}
                  </div>
                  <div
                    className='text-base md:text-[22px] leading-relaxed group-hover:opacity-0 transition-opacity duration-300'>
                    {fm('We believe lasting social, environmental, and economic change begins with the transformation of human consciousness.')}
                  </div>
                </div>
                <div className='flex mt-6 justify-end md:justify-startrelative z-10'>
                  <img src={imgs['circle_right.svg']} alt="Arrow" className='w-12 h-12'/>
                </div>
              </div>

              {/* Education For All */}
              <div
                onClick={() => navigate('/ourservice/education')}
                className='group relative bg-[#1C4B3A] rounded-2xl p-8 text-white cursor-pointer overflow-hidden flex flex-col justify-between min-h-[300px] transition-all duration-500'
              >
                <img src={imgs['Meditationb.svg']} className='block md:hidden w-[50px]'/>
                <img
                  src={imgs['Group 2.png']}
                  alt="Education For All"
                  className='absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-500'
                />
                <div className='relative z-10'>
                  <div className='text-2xl md:text-4xl font-bold mb-4'>
                    {fm('EDUCATION FOR ALL')}
                  </div>
                  <div
                    className='text-base md:text-[22px] leading-relaxed group-hover:opacity-0 transition-opacity duration-300'>
                    {fm('Every child carries infinite potential. We support education so that potential is not determined by circumstance, but unlocked through opportunity.')}
                  </div>
                </div>
                <div className='flex mt-6 justify-end md:justify-startrelative z-10'>
                  <img src={imgs['circle_right.svg']} alt="Arrow" className='w-12 h-12'/>
                </div>
              </div>

              {/* Thriving Communities */}
              <div
                onClick={() => navigate('/ourservice/communities')}
                className='group relative bg-[#8B3F2B] rounded-2xl p-8 text-white cursor-pointer overflow-hidden flex flex-col justify-between min-h-[300px] transition-all duration-500'
              >
                <img src={imgs['Hand Heartc.svg']} className='block md:hidden w-[50px]'/>
                <img
                  src={imgs['Group 3.png']}
                  alt="Thriving Communities"
                  className='absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-500'
                />
                <div className='relative z-10'>
                  <div className='text-2xl md:text-4xl font-bold mb-4'>
                    {fm('THRIVING COMMUNITIES')}
                  </div>
                  <div
                    className='text-base md:text-[22px] leading-relaxed group-hover:opacity-0 transition-opacity duration-300'>
                    {fm('We believe that every person has the right to live a life of dignity and have equal opportunity to thrive.')}
                  </div>
                </div>
                <div className='flex mt-6 justify-end md:justify-startrelative z-10'>
                  <img src={imgs['circle_right.svg']} alt="Arrow" className='w-12 h-12'/>
                </div>
              </div>
            </div>

            {/* Bottom Row - 2 cards centered */}
            <div className='grid grid-cols-1 md:grid-cols-2 gap-6 mx-auto'>
              {/* Platform for Changemakers */}
              <div
                onClick={() => navigate('/ourservice/changemakers')}
                className='group relative bg-[#2B4C6F] rounded-2xl p-8 text-white cursor-pointer overflow-hidden flex flex-col justify-between min-h-[300px] transition-all duration-500'
              >
                <img src={imgs['puzzlee.svg']} className='block md:hidden w-[50px]'/>
                <img
                  src={imgs['Group 4.png']}
                  alt="Platform for Changemakers"
                  className='absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-500'
                />
                <div className='relative z-10'>
                  <div className='text-2xl md:text-4xl font-bold mb-4'>
                    {fm('PLATFORM FOR CHANGEMAKERS')}
                  </div>
                  <div
                    className='text-base md:text-[22px] leading-relaxed group-hover:opacity-0 transition-opacity duration-300'>
                    {fm('We support social entrepreneurs, Changemakers and system builders addressing the root causes of inequality through innovative, locally grounded, and values-driven solutions.')}
                  </div>
                </div>
                <div className='flex mt-6 justify-end md:justify-startrelative z-10'>
                  <img src={imgs['circle_right.svg']} alt="Arrow" className='w-12 h-12'/>
                </div>
              </div>

              {/* Inspiring Vietnam */}
              <div
                onClick={() => navigate('/ourservice/inspiring-vietnam')}
                className='group relative bg-[#8C1D18] rounded-2xl p-8 text-white cursor-pointer overflow-hidden flex flex-col justify-between min-h-[300px] transition-all duration-500'
              >
                <img src={imgs['Heart Pulsee.svg']} className='block md:hidden w-[50px]'/>
                <img
                  src={imgs['Group 5.png']}
                  alt="Inspiring Vietnam"
                  className='absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-500'
                />
                <div className='relative z-10'>
                  <div className='text-2xl md:text-4xl font-bold mb-4'>
                    {fm('INSPIRING VIETNAM')}
                  </div>
                  <div
                    className='text-base md:text-[22px] leading-relaxed group-hover:opacity-0 transition-opacity duration-300'>
                    {fm('Highlighting unheard voices and untold stories, we strive to increase participation and representation, ensuring these vital narratives contribute to social change')}
                  </div>
                </div>
                <div className='flex mt-6 justify-end md:justify-startrelative z-10'>
                  <img src={imgs['circle_right.svg']} alt="Arrow" className='w-12 h-12'/>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* bottom part - Quote section */}
        <div className='relative -mb-1 md:mb-auto md:py-20 px-5 md:px-10 h-[150px] md:h-[400px] flex items-center justify-end'>
          <img
            src={imgs['Group 30091.png']}
            alt="Quote Background"
            className='absolute inset-0 w-full h-[150px] md:h-auto'
          />
          <div className='relative mt-0 md:-mt-10 z-10 max-w-[205px] md:max-w-2xl mx-auto'>
            <div className='text-xs md:text-2xl text-gray-800 leading-[1.3] md:leading-relaxed text-center'>
              {
                locale === 'en' ?
                  <>
                    If you want to awaken all of humanity, then <b>awaken all of yourself</b>. If you want to eliminate the suffering in the world, then eliminate all that is dark and negative in yourself. Truly, the greatest gift you have to give is that of your own <b>self-transformation</b>.
                  </> :
                  <>
                    Nếu bạn muốn đánh thức toàn bộ nhân loại, thì hãy thức tỉnh chính mình. Nếu bạn muốn loại bỏ những đau khổ trên thế giới, thì hãy loại bỏ tất cả những gì tăm tối và tiêu cực trong chính bạn. Món quà lớn nhất mà bạn có thể ban tặng là sự tự chuyển hóa của chính bạn.
                  </>
              }
            </div>
          </div>
        </div>

      </div>
  );
}

const VideoComponent = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const handleIntersection = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          videoRef.current.play();
        } else {
          videoRef.current.pause();
        }
      });
    };

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    };

    const observer = new IntersectionObserver(handleIntersection, options);

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);
      }
    };
  }, []);

  return (
    <video
      controls
      ref={videoRef}
      muted
      className='video'
      src='https://file.udty.tech/20240527/1716781766084_Intro%20Video%20Main.mp4'
    />
  );
};

export default Home;

